import { useDispatch, useSelector } from 'react-redux';
import Modal from 'react-bootstrap/Modal';
import styled from 'styled-components';

import { ButtonLoader } from 'components/Loader';

import { closeModel } from 'redux/model';
import { updateOpticalCustomer, updateOpticalCustomerStatus } from 'redux/store';
import { showSnackbar } from 'redux/snackbar';

import { ModelBtn } from 'styles';
import { useState } from 'react';

export const ModelTitle = styled(Modal.Title).attrs({
  className: 'w-100 filson-pro-bold'
})`
  font-size: 100%;
  text-align: center;
`;

const OpticalCustomer = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const { data } = useSelector((state) => state.model);

  const handleConfirm = () => {
    setIsLoading(true);
    let payload = {
      memberNumber: data.memberNumber,
      isOpticalCustomer: data.isEnabled
    };
    dispatch(updateOpticalCustomer(payload))
      .then(() => {
        // Update Redux state with latest optical customer details
        dispatch(
          updateOpticalCustomerStatus({
            memberNumber: data.memberNumber,
            isOpticalCustomer: data.isEnabled
          })
        );
        // Show success message
        dispatch(
          showSnackbar({
            message: `Optical customer status updated successfully`,
            severity: 'success'
          })
        );
        // Call the confirm callback to update toggle state
        if (data.onConfirm) {
          data.onConfirm();
        }
        dispatch(closeModel());
      })
      .catch((err) => {
        console.log(err);
        dispatch(showSnackbar({ message: err?.data?.message, severity: 'error' }));
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleClose = () => {
    // Call the cancel callback to reset toggle state
    if (data.onCancel) {
      data.onCancel();
    }
    dispatch(closeModel());
  };

  return (
    <>
      <Modal.Header closeButton>
        <ModelTitle>Optical Customer</ModelTitle>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-5">
          <p className="text-center filson-pro-regular font15px">
            Are you sure you want to change this member’s optical customer status?
          </p>
          <div className="text-center mb-3">
            <ModelBtn className="mdl-btn" onClick={handleClose}>
              Cancel
            </ModelBtn>
            <ModelBtn
              onClick={handleConfirm}
              className={isLoading ? 'disable-btn' : 'active-btn'}
              isProcessing={isLoading}
              disabled={isLoading}>
              {isLoading ? <ButtonLoader /> : 'Confirm'}
            </ModelBtn>
          </div>
        </div>
      </Modal.Body>
    </>
  );
};

export default OpticalCustomer;
